import base from './base';

const industryAPI = dispatch => {
    return {
        async getCompetitors(code, data) {
              return await base.privateApi(dispatch, {
                path: `/industry/${code}/stocks`,
                method: 'post',
                data,
              });
            },

        async getLineChartCompetitors(symbol, period) {
            return base.privateApi(dispatch, {
                path: `/industry/${symbol}/line/${period}`,
                method: 'get'
            });
        },

        async getBubbleChartCompetitors(symbol) {
            return base.privateApi(dispatch, {
                path: `/industry/${symbol}/bubble`,
                method: 'get'
            });
        },

        async getIndicatorLineChart(symbol, indicator) {
            return base.privateApi(dispatch, {
                path: `/industry/${symbol}/${indicator}/line`,
                method: 'get'
            });
        },
    }
}

export default industryAPI;